<template>
  <div class="withdrawal">
    <h3 v-if="role == 1">充值账户提现</h3>
    <h3 v-else>收入账户提现</h3>
    <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
      <el-form-item label="用户编号">
        <el-input v-model.number="filter.userId" placeholder="用户编号"></el-input>
      </el-form-item>
      <el-form-item label="提现人">
        <el-input v-model.number="filter.receiveName" placeholder="提现人"></el-input>
      </el-form-item>
      <el-form-item label="账单状态">
        <el-select v-model="filter.status" placeholder="请选择账单状态" v-if="role == 1">
          <el-option label="全部" value=""></el-option>
          <el-option label="待处理" value="1"></el-option>
          <el-option label="已确认" value="2"></el-option>
          <el-option label="已驳回" value="3"></el-option>
        </el-select>
        <el-select v-model="filter.status" @change="statusChange" placeholder="请选择账单状态" v-else>
          <el-option label="全部" value=""></el-option>
          <el-option label="待转账" value="1"></el-option>
          <el-option label="可转账" value="6"></el-option>
          <el-option label="处理中" value="7"></el-option>
          <el-option label="已到账" value="2"></el-option>
          <el-option label="转账失败" value="5"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="提现账户" v-if="role==1">
        <el-input v-model="filter.name" placeholder="请填写提现账户"></el-input>
      </el-form-item> -->
      <el-form-item label="银行开户行支行" v-if="role == 1">
        <el-input v-model="filter.receiveBankName" placeholder="请填写银行开户行支行"></el-input>
      </el-form-item>
      <el-form-item label="银行账号" v-if="role == 1">
        <el-input v-model="filter.receiveAccount" placeholder="请填写银行账号"></el-input>
      </el-form-item>

      <el-form-item label="账户流水号">
        <el-input v-model="filter.transactionId" placeholder="请填写账户流水号"></el-input>
      </el-form-item>
      <el-form-item label="提现时间">
        <el-col :span="11">
          <el-date-picker v-model="filter.createTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间" :picker-options="topupOptionsStart" style="margin-right: 10px">
          </el-date-picker>
        </el-col>
        <el-col class="tcenter" :span="2">至</el-col>
        <el-col :span="11">
          <el-date-picker v-model="filter.createTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间" :picker-options="topupOptionsEnd" style="margin-left: 10px">
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="可转账时间" v-if="role == 2">
        <el-col :span="11">
          <el-date-picker v-model="filter.withdrawalTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间" :picker-options="topupOptionsStart" style="margin-right: 10px">
          </el-date-picker>
        </el-col>
        <el-col class="tcenter" :span="2">至</el-col>
        <el-col :span="11">
          <el-date-picker v-model="filter.withdrawalTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间" :picker-options="topupOptionsEnd" style="margin-left: 10px">
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="操作时间" v-if="role == 1">
        <el-col :span="11">
          <el-date-picker v-model="filter.confirmTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间" :picker-options="topupOptionsStart" style="margin-right: 10px">
          </el-date-picker>
        </el-col>
        <el-col class="tcenter" :span="2">至</el-col>
        <el-col :span="11">
          <el-date-picker v-model="filter.confirmTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间" :picker-options="topupOptionsEnd" style="margin-left: 10px">
          </el-date-picker>
        </el-col>
      </el-form-item>

      <el-form-item label="转账操作时间" v-if="role == 2">
        <el-col :span="11">
          <el-date-picker v-model="filter.launchTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间" :picker-options="topupOptionsStart" style="margin-right: 10px">
          </el-date-picker>
        </el-col>
        <el-col class="tcenter" :span="2">至</el-col>
        <el-col :span="11">
          <el-date-picker v-model="filter.launchTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间" :picker-options="topupOptionsEnd" style="margin-left: 10px">
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="到账时间" v-if="role == 2">
        <el-col :span="11">
          <el-date-picker v-model="filter.notifyTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间" :picker-options="topupOptionsStart" style="margin-right: 10px">
          </el-date-picker>
        </el-col>
        <el-col class="tcenter" :span="2">至</el-col>
        <el-col :span="11">
          <el-date-picker v-model="filter.notifyTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间" :picker-options="topupOptionsEnd" style="margin-left: 10px">
          </el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-left: 10px" type="primary" @click="fetch(1)" size="mini">查询</el-button>
        <el-button type="primary" size="mini" @click="resetting">重置</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-if="role == 1">
      <el-table-column prop="userId" label="用户编号"></el-table-column>
      <el-table-column label="账单状态">
        <template slot-scope="scope">
          <template v-if="role != 1 && map.finance.status[scope.row.status] == '处理中'">
            {{ (scope.row.taskId != null && scope.row.taskId != '-1') ? "处理中" : "待处理" }}
          </template>
          <template v-else>
            {{ map.finance.status[scope.row.status] }}
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="receiveName" width="120px" label="提现人" />
      <el-table-column prop="name" width="120px" label="企业信息" />
      <el-table-column prop="amount" width="140" label="提现金额" align="center"></el-table-column>
      <el-table-column prop="receiveBank" width="160px" label="收款银行" />
      <el-table-column prop="bankProvince" label="银行省份"></el-table-column>
      <el-table-column prop="bankCity" label="银行城市"></el-table-column>
      <el-table-column prop="receiveBankName" label="银行开户行支行" width="160px"></el-table-column>
      <el-table-column prop="receiveAccount" width="160px" label="银行账号" />
      <el-table-column prop="createTime" label="提现时间" sortable width="180"></el-table-column>
      <el-table-column prop="confirmTime" label="操作时间" sortable width="180"></el-table-column>
      <el-table-column label="打款凭证" v-if="role == 1">
        <template slot-scope="scope"><a v-if="scope.row.transferProve" target="_blank"
            :href="scope.row.transferProve">查看</a></template>
      </el-table-column>
      <el-table-column prop="transactionId" label="账户流水号" width="200"></el-table-column>
      <el-table-column prop="withdrawalId" label="提现编号" width="180px" />
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <!-- <el-table-column prop="operator" label="提现账户"></el-table-column> -->
      <!-- <el-table-column prop="id" label="账单ID"></el-table-column> -->
      <!-- <el-table-column prop="amount" label="提现金额/元"></el-table-column> -->

      <!-- <el-table-column width="160px" prop="notifyStatusMessage" label="众包支付接口返回信息" /> -->
      <el-table-column prop="rejectReason" label="备注" />
      <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="primary" v-if="role == 1" :disabled="scope.row.status !== 1" @click="review(scope.row)">提审</el-button>-->
          <template v-if="scope.row.isDeleted != 1">
            <!-- <el-button size="mini" type="primary"
              v-if="scope.row.status === 4 && scope.row.unfold!==1&& role != 1 && getShowBtn(scope.row.createTime)"
              :disabled="scope.row.taskId != null && scope.row.taskId != '-1'"
              @click="transferAccount(scope.row)">转账</el-button> -->
            <el-button size="mini" type="primary" v-if="role == 1" :disabled="scope.row.status !== 1"
              @click="toggleDialog('confirm', scope.row)">确认</el-button>
          </template>
          <el-tag v-if="role == 1 && scope.row.isDeleted == 1" size="mini" type="danger">用户已禁用</el-tag>
          <el-button size="mini" type="primary" v-if="role == 1" :disabled="scope.row.status !== 1"
            @click="toggleDialog('reject', scope.row)">驳回</el-button>
          <!-- <el-button size="mini" type="primary" v-if="scope.row.status == 5 || scope.row.status == 3"
            @click="updateStart(scope.row)">重新发起</el-button> -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" fixed="right" width="240"></el-table-column>
      <el-table-column label="操作" fixed="right" width="240"></el-table-column> -->
      <div slot="append">
        <div class="footer_bottom">
          <div class="footer_left">当页合计金额</div>
          <div>
            <div class="" style="margin-left: 129px;">
              {{ currentPageTotalAmount ? currentPageTotalAmount : 0 }}
            </div>
          </div>
        </div>
        <div class="footer_bottom">
          <div class="footer_left">汇总合计金额</div>
          <div>
            <div class="" style="margin-left: 129px;">
              {{ totalAmount ? totalAmount : 0 }}
            </div>
          </div>
        </div>
      </div>
    </el-table>
    <el-table :data="list" size="mini" v-if="role == 2">
      <!-- <el-table-column prop="id" label="提现编号"></el-table-column> -->
      <el-table-column prop="userId" label="用户编号"></el-table-column>
      <el-table-column label="提现状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 4 && scope.row.unfold !== 1">可转账</span>
          <span v-else> {{ map.finance.partBstatus[scope.row.status] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="receiveName" width="120px" label="提现人" />
      <el-table-column prop="amount" width="140" label="提现金额" align="center"></el-table-column>
      <el-table-column prop="createTime" label="提现时间" sortable width="180"></el-table-column>
      <el-table-column prop="withdrawalTime" label="可转账时间" sortable width="180"></el-table-column>
      <el-table-column prop="launchTime" label="转账操作时间" sortable width="180"></el-table-column>
      <el-table-column prop="notifyTime" label="到账时间" sortable width="180"></el-table-column>
      <el-table-column prop="transactionId" label="账户流水号" width="200"></el-table-column>
      <el-table-column prop="withdrawalId" label="提现编号" width="180px" />
      <el-table-column prop="operator" label="转账操作人"></el-table-column>
      <el-table-column prop="receiveBank" width="160px" label="收款银行" />
      <el-table-column prop="receiveAccount" width="160px" label="银行账号" />
      <el-table-column prop="bankPhone" width="160px"  label="预留手机号"></el-table-column>
      <el-table-column prop="rejectReason" label="备注" />
      <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <!-- <el-button size="mini" type="primary" v-if="role == 1" :disabled="scope.row.status !== 1" @click="review(scope.row)">提审</el-button>-->
          <template v-if="scope.row.isDeleted != 1">
            <el-button size="mini" type="primary"
              v-if="scope.row.status === 4 && scope.row.unfold !== 1 && getShowBtn(scope.row.createTime)"
              :disabled="scope.row.taskId != null && scope.row.taskId != '-1'"
              @click="transferAccount(scope.row)">转账</el-button>
            <el-button size="mini" type="primary" v-if="role == 1" :disabled="scope.row.status !== 1"
              @click="toggleDialog('confirm', scope.row)">确认</el-button>
          </template>
          <el-button size="mini" type="primary" v-if="role == 1" :disabled="scope.row.status !== 1"
            @click="toggleDialog('reject', scope.row)">驳回</el-button>
          <el-button size="mini" type="primary" v-if="scope.row.status == 5 || scope.row.status == 3"
            @click="updateStart(scope.row)">重新发起</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" fixed="right" width="240"></el-table-column>
      <el-table-column label="操作" fixed="right" width="240"></el-table-column> -->
      <div slot="append">
        <div class="footer_bottom">
          <div class="footer_left">当页合计金额</div>
          <div>
            <div class="" style="margin-left: 129px;">
              {{ currentPageTotalAmount ? currentPageTotalAmount : 0 }}
            </div>
          </div>
        </div>
        <div class="footer_bottom">
          <div class="footer_left">汇总合计金额</div>
          <div>
            <div class="" style="margin-left: 129px;">
              {{ totalAmount ? totalAmount : 0 }}
            </div>
          </div>
        </div>
      </div>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination background layout="prev, pager, next" :page-size="20" @current-change="(i) => (pageNum = i)"
        :page-count="pageNum" :total="total" ref="pagination">
      </el-pagination>
    </div>
    <el-dialog title="请填写驳回理由" :visible.sync="dialog.reject">
      <el-input type="textarea" placeholder="请填写驳回理由" :rows="5" v-model.trim="rejectReason" maxlength="50" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.reject = false">取 消</el-button>
        <el-button type="primary" @click="updateClientWithdrawal(curData, 3, 'reject')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="上传打款凭证" :visible.sync="dialog.confirm">
      <el-form :model="confirmForm" :rules="rules" ref="confirmForm">
        <el-form-item prop="transferProve">
          <el-upload class="avatar-uploader" action="https://up-z1.qbox.me/" :show-file-list="false"
            :on-success="handleSuccess" :before-upload="beforeUpload" :data="uploadData" accept="image/png, image/jpeg">
            <img v-if="confirmForm.transferProve" :src="confirmForm.transferProve" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">上传打款凭证
            </i>
            <div slot="tip" class="el-tip">只能上传jpg/png文件，且不超过5M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.confirm = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdate(confirmForm, 'confirm', 2)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="重新发起提现" :visible.sync="dialogVisibleStart" width="40%" :before-close="closeStart">
      <el-form :model="formStart" label-width="120px" :rules="rulesStart" ref="formStart">
        <el-form-item label="收款账号:" prop="account">
          <el-input clearable v-model.trim="formStart.account"></el-input>
        </el-form-item>
        <el-form-item label="收款人:" prop="name">{{ formStart.name }}
        </el-form-item>
        <el-form-item label="手机号码:" prop="phoneNumber">{{ formStart.phoneNumber }}
        </el-form-item>
        <el-form-item label="身份证号码:" prop="idCard">
          {{ formStart.idCard }}</el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeStart('formStart')">取 消</el-button>
        <el-button type="primary" @click="submitStart">发 起</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";
const { withdrawal, upload } = api;

import moment from "moment";

export default {
  name: "withdrawal",
  data() {
    return {
      map,
      loading: true,
      list: [],
      currentPageTotalAmount: 0,
      totalAmount: 0,
      total: 0,
      pageNum: 1,
      limit: 20,
      filter: {
        transactionId: "",
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        withdrawalTimeEnd: "",
        withdrawalTimeStart: "",
        launchTimeStart: "",
        launchTimeEnd: "",
        confirmTimeEnd: '',
        confirmTimeStart: '',
        notifyTimeEnd: "",
        notifyTimeStart: "",
        receiveBankName: '',
        receiveAccount: "",
        name: "",
        userId: this.$route.query.userId,
        pageNum: 1,
        receiveName: "",
        limit: 20,
      },
      rejectReason: "",
      dialog: {
        reject: false,
        confirm: false,
      },
      curData: {},
      confirmForm: {
        transferProve: "",
      },
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },
      formStart: {
        account: "",
        idCard: "",
        name: "",
        phoneNumber: "",
      },
      rulesStart: {},
      dialogVisibleStart: false,
      rulesStart: {
        account: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
        ],
      },
      rules: {
        transferProve: [
          {
            required: true,
            message: "请上传打款凭证",
          },
        ],
      },
      topupOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.filter.topupEndDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      topupOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.filter.topupStartDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      zlbDate: "1686153600000", //提现系统主体转移时间
      isSubmiting: false,
    };
  },
  computed: {
    role() {
      return this.$route.params.role;
    },
    username() {
      return localStorage.getItem("username");
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
    role() {
      this.filter = {
        transactionId: "",
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        withdrawalTimeEnd: "",
        withdrawalTimeStart: "",
        launchTimeStart: "",
        launchTimeEnd: "",
        notifyTimeEnd: "",
        notifyTimeStart: "",
        confirmTimeEnd: '',
        confirmTimeStart: '',
        receiveName: "",
        receiveBankName: '',
        receiveAccount: "",

        name: "",
      };
      this.fetch();
    },
  },
  methods: {
    statusChange(e) {
      if (e == 6) {
        const now = new Date();
        const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        yesterday.setHours(23, 59, 59, 0);
        this.filter.createTimeEnd = moment(yesterday).format("YYYY-MM-DD HH:mm:ss")
      } else {
        this.filter.createTimeEnd = ''
      }
    },
    async fetch(num) {
      if (num == 1) this.pageNum = 1;

      this.loading = true;
      let {
        transactionId,
        status,
        createTimeStart,
        createTimeEnd,
        withdrawalTimeEnd,
        withdrawalTimeStart,
        launchTimeStart,
        launchTimeEnd,
        notifyTimeEnd,
        notifyTimeStart,
        confirmTimeEnd,
        confirmTimeStart,
        receiveBankName,
        receiveAccount,

        name,
        userId,
        receiveName,
      } = this.filter;
      let obj = {
        transactionId,
        status,
        createTimeStart,
        createTimeEnd,
        withdrawalTimeEnd,
        withdrawalTimeStart,
        receiveBankName,
        receiveAccount,

        launchTimeStart,
        launchTimeEnd,
        notifyTimeEnd,
        notifyTimeStart,
        confirmTimeEnd,
        confirmTimeStart,
        name,
        // userId: Number.isInteger(userId) ? userId : "",
        userId: this.$route.query.userId ? this.$route.query.userId : userId,
        role: this.role,
        pageNum: this.pageNum,
        limit: this.limit,
        receiveName,
      };
      let res = await withdrawal.list(obj);
      this.list = res.data.data;
      this.currentPageTotalAmount = res.data.currentPageTotalAmount;
      this.totalAmount = res.data.totalAmount;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    async getToken() {
      let res = await upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    submitUpdate(item, name, status) {
      this.$refs["confirmForm"].validate((valid) => {
        if (valid) {
          this.updateClientWithdrawal(item, status, name);
        } else {
          return false;
        }
      });
    },
    async review(item) {
      let obj = {
        withdrawalId: item.withdrawalId,
      };
      let res = await withdrawal.review(obj);
      console.log(res);
      let { code } = res.data;
      if (code === 200) {
        this.$message.success("更新数据成功");
        this.fetch();
      }
    },
    async updateClientWithdrawal(data, status, name) {
      console.log(name);
      let withdrawalId =
        status == 2 ? this.curData.withdrawalId : data.withdrawalId;

      let obj = {
        withdrawalId: withdrawalId,
        status: status,
        transferProve: data.transferProve,
        rejectReason: this.rejectReason,
      };

      let res =
        this.role == 1
          ? await withdrawal.updateClient(obj)
          : await withdrawal.updateProvider(obj);

      let { code } = res.data;
      if (code === 200) {
        this.$message.success("更新数据成功");
        this.toggleDialog(name);
        this.confirmForm = {};
        this.fetch();
      }
    },
    toggleDialog(name, data) {
      this.dialog[name] = !this.dialog[name];
      if (data) this.curData = data;
    },
    // 时间开始选择器
    startTimeStatus: function (name, value) {
      this.filter.name = value;
    },
    // 时间结束选择器
    endTimeStatus: function (name, value) {
      this.filter.name = value;
    },
    handleSuccess(res, file) {
      this.confirmForm.transferProve = `https:\/\/image.duiyou360.com/${res.key
        }`;
    },
    beforeUpload(file) {
      const sizeM = file.size / 1024 / 1024;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt5M = sizeM < 5;
      if (!isJPG || !isLt5M) {
        this.$message.error("只能上传jpg/png文件，且不超过5M!");
      } else {
        this.uploadData.name = file.name;
      }
      return isJPG && isLt5M;
    },
    resetting() {
      this.filter = {
        transactionId: "",
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        withdrawalTimeEnd: "",
        withdrawalTimeStart: "",
        launchTimeStart: "",
        launchTimeEnd: "",
        notifyTimeEnd: "",
        notifyTimeStart: "",
        confirmTimeEnd: '',
        confirmTimeStart: '',
        receiveBankName: '',
        receiveAccount: '',

        receiveName: "",
        name: "",
      };
    },
    async exportExcel() {
      this.loading = true;
      let {
        transactionId,
        status,
        createTimeStart,
        createTimeEnd,
        withdrawalTimeEnd,
        withdrawalTimeStart,
        launchTimeStart,
        launchTimeEnd,
        notifyTimeEnd,
        receiveBankName,
        receiveAccount,
        notifyTimeStart,
        confirmTimeEnd,
        confirmTimeStart,
        name,
        userId,
      } = this.filter;
      let obj = {
        transactionId,
        status,
        createTimeStart,
        createTimeEnd,
        withdrawalTimeEnd,
        withdrawalTimeStart,
        launchTimeStart,
        receiveAccount,
        launchTimeEnd,
        receiveBankName,
        notifyTimeEnd,
        notifyTimeStart,
        confirmTimeEnd,
        confirmTimeStart,
        name,
        role: this.role,
        pageNum: this.pageNum,
        limit: this.limit,
        userId: this.$route.query.userId ? this.$route.query.userId : userId,
      };
      let resp = await withdrawal.export(obj);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      // console.log(link);
      let title = this.role == 1 ? "充值账户提现列表" : "收入账户提现列表";
      link.download = decodeURIComponent(title + ".xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
    // 重新发起
    updateStart(row) {
      console.log(row.id);
      this.dialogVisibleStart = true;
      let id = row.id;

      withdrawal.withdrawalId({ id }).then((res) => {
        if (res.data.code == 200) {
          this.formStart = res.data.data;
        } else {
          this.$message.error(res.desc);
        }
      });
    },
    //转账
    transferAccount(row) {
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("span", null, "确定转账："),
          h("span", { style: "color: red;font-weight:600;" }, `¥${row.amount}`),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定转账",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            withdrawal
              .transferAccount({
                id: row.id,
                withdrawalId: row.withdrawalId,
                type: 2,
                // nickName:this.username
              })
              .then((res) => {
                if (res.data.code == 200) {
                  done();
                  instance.confirmButtonLoading = false;
                  this.fetch();
                } else {
                  done();
                  instance.confirmButtonLoading = false;
                  this.$message({
                    type: "error",
                    message: "转账失败",
                  });
                }
              });
          } else {
            done();
            this.$message({
              type: "info",
              message: "已取消",
            });
          }
        },
      }).then();
    },
    getShowBtn(time) {
      if (new Date(time).getTime() > +this.zlbDate) {
        return true;
      } else {
        return false;
      }
    },
    closeStart(formStart) {
      this.dialogVisibleStart = false;
      this.$refs[formStart].resetFields();
    },
    submitStart() {
      this.$refs["formStart"].validate((valid) => {
        if (valid) {
          withdrawal.againLaunchPay(this.formStart).then((res) => {
            if (res.data.code == 200) {
              this.$message.success("操作成功");
            } else {
              this.$message.error("操作失败");
            }
            this.fetch();
            this.dialogVisibleStart = false;
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.fetch();
    this.getToken();
  },
};
</script>
<style >
.avatar-uploader .el-upload {
  width: 100%;
  border: 1px dashed #9ca6ae;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  max-width: 100%;
  max-height: 300px;
  vertical-align: middle;
}

/* .el-table__append-wrapper{
  width:2520px;
} */

.footer_bottom {
  height: 30px;
  display: flex;
  align-items: center;
}

.footer_bottom2 {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1260px;
  width: 140px;
}

.footer_left {
  width: 120px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/finance/withdrawal.vue